<template>
  <svg
    fill="none"
    height="38"
    viewBox="0 0 38 38"
    width="38"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5404 11.8749C24.5404 14.9355 22.0593 17.4166 18.9987 17.4166C15.9381 17.4166 13.457 14.9355 13.457 11.8749C13.457 8.81434 15.9381 6.33325 18.9987 6.33325C22.0593 6.33325 24.5404 8.81434 24.5404 11.8749Z"
      fill="white"
    />
    <path
      d="M30.8737 11.8748C30.8737 14.061 29.1015 15.8332 26.9154 15.8332C24.7293 15.8332 22.957 14.061 22.957 11.8748C22.957 9.68871 24.7293 7.9165 26.9154 7.9165C29.1015 7.9165 30.8737 9.68871 30.8737 11.8748Z"
      fill="white"
      opacity="0.4"
    />
    <path
      d="M7.125 11.8748C7.125 14.061 8.89721 15.8332 11.0833 15.8332C13.2695 15.8332 15.0417 14.061 15.0417 11.8748C15.0417 9.68871 13.2695 7.9165 11.0833 7.9165C8.89721 7.9165 7.125 9.68871 7.125 11.8748Z"
      fill="white"
      opacity="0.4"
    />
    <path
      d="M28.5 26.1249C28.5 29.1855 24.2467 31.6666 19 31.6666C13.7533 31.6666 9.5 29.1855 9.5 26.1249C9.5 23.0643 13.7533 20.5833 19 20.5833C24.2467 20.5833 28.5 23.0643 28.5 26.1249Z"
      fill="white"
    />
    <path
      d="M34.8327 26.1248C34.8327 28.3109 31.9971 30.0832 28.4993 30.0832C25.0016 30.0832 22.166 28.3109 22.166 26.1248C22.166 23.9387 25.0016 22.1665 28.4993 22.1665C31.9971 22.1665 34.8327 23.9387 34.8327 26.1248Z"
      fill="white"
      opacity="0.4"
    />
    <path
      d="M3.16602 26.1248C3.16602 28.3109 6.00154 30.0832 9.49935 30.0832C12.9972 30.0832 15.8327 28.3109 15.8327 26.1248C15.8327 23.9387 12.9972 22.1665 9.49935 22.1665C6.00154 22.1665 3.16602 23.9387 3.16602 26.1248Z"
      fill="white"
      opacity="0.4"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForIcon4',
}
</script>